import { useQuery } from 'react-query'

import { getCategories } from '../../endpoints/howTo'

export const useGetCategories = () => {
    return useQuery(['zendesk-categories'], async () => await getCategories(), {
        refetchOnWindowFocus: false
    })
}
